export default "__VITE_ASSET__Coz7yd0___"